import { FetchProductsQueryResponse } from '../../../../products/queries/fetchProducts.query';
import { ComposerDockProductItemProduct } from '../../ComposerDockProductItem';

// Maps a fetched product node to the compact shape the dock card renders. The
// id is stringified from nanoId to stay consistent with how products are keyed
// elsewhere in the composer (see SelectedProductsSidebarFooter).
function mapProductToDockItem(
  product: FetchProductsQueryResponse
): ComposerDockProductItemProduct {
  return {
    id: String(product.nanoId),
    name: product.name,
    image: product.image?.file ? { file: product.image.file } : null,
    brand: product.brand
      ? {
          name: product.brand.name,
          localizedName: product.brand.localizedName
        }
      : null,
    previewModel: product.previewModel?.file
      ? { file: product.previewModel.file }
      : null
  };
}

export { mapProductToDockItem };

export default mapProductToDockItem;
